/**
 * Validates the input of the angular ui bootstrap datepicker to be within the min-date and max-date
 */
(function(){
    angular
        .module('maApp.validation')
        .directive('datepickerRange', datepickerRange);

    datepickerRange.$inject = [];

    function datepickerRange(){
        return {
            require: 'ngModel',
            link: function(scope, elm, attrs, ctrl) {
                ctrl.$validators.datepickerRange = datepickerRange;

                function datepickerRange(modelValue){

                    var min = scope.$eval(attrs['minDate']);
                    var max = scope.$eval(attrs['maxDate']);
                    var minDate, maxDate;

                    if(min){
                        minDate = Date.create(min).reset();
                    }

                    if(max){
                        maxDate = Date.create(max).reset();
                    }

                    var modelDate = Date.create(modelValue).reset();

                    return minDate &&
                        minDate.isValid() &&
                        maxDate &&
                        maxDate.isValid() &&
                        modelValue &&
                        modelDate.isValid() &&
                        (modelDate.isBetween(minDate, maxDate) ||
                        modelDate.is(minDate) ||
                        modelDate.is(maxDate));

                }

            }
        };
    }
})();